import React from "react"
import classnames from "classnames"
import TopicCategories from "./TopicCategories"
import LatestZones from "./LatestZones"
import TrendingZones from "./TrendingZones"
import Footer from "./Footer"

const ModernHomepage = ({ 
  categories = [], 
  latestThreads = [], 
  trendingThreads = [],
  stats = {},
  user 
}) => {
  return (
    <div className="modern-homepage">
      <div className="container">
        {/* Topic Categories Section */}
        <TopicCategories 
          categories={categories}
          stats={stats}
        />
        
        <div className="homepage-content-grid">
          {/* Latest Zones Section */}
          <div className="latest-zones-section">
            <LatestZones 
              threads={latestThreads}
              user={user}
            />
          </div>
          
          {/* Trending Zones Section */}
          <div className="trending-zones-section">
            <TrendingZones 
              threads={trendingThreads}
              user={user}
            />
          </div>
        </div>
      </div>
      
      {/* Footer Section */}
      <Footer />
    </div>
  )
}

export default ModernHomepage